import React from 'react'

export function Header({ children }) {
  return <div className="flexbox-grow">{children}</div>
}

export function Title({ children }) {
  return (
    <div className="font-family-system font-size-largest font-weight-bold margin-bottom-normal">
      {children}
    </div>
  )
}

export function Subtitle({ children }) {
  return (
    <div className="font-family-system font-weight-semibold font-size-larger margin-bottom-normal">
      {children}
    </div>
  )
}

export function Informations({ children }) {
  return (
    <div className="font-size-normal shade-10 line-height-larger">
      {children}
    </div>
  )
}

export function Body({ children }) {
  return <div className="padding-vertical-normal">{children}</div>
}

export function Footer({ children }) {
  return (
    <div className="margin-top-large padding-vertical-small flexbox flexbox-space-between">
      {children}
    </div>
  )
}
